export const getChangePayMethodViewAction = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD";
export const getChangePayMethodViewSuccessAction = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD/SUCCESS";
export const getChangePayMethodViewFailAction = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD/FAIL";
export const getChangePayMethodViewResetAction = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD/RESET";

export const getChangePayMethodRefundPush = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD/PUSH";
export const getChangePayMethodRefundPop = "MEMEBER_SERVICE/VIEW/CHANGE_PAY_METHOD/POP";
